/**
 * FlowTable's default-cell formatting (plan 2026-09-28-001 U1, clay 11) —
 * extracted so `LedgerTable` can share it instead of duplicating
 * `formatDefault`. Pure: no React, no Glaze — `null` is the caller's cue to
 * render its own em-dash span instead of a plain string.
 */

/** FlowTable's default-cell vocabulary, minus the JSX: null for "render the
 *  caller's em-dash span". */
export function formatCellValue(v: unknown): string | number | null {
  if (v == null || v === '') return null;
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (typeof v === 'number') return Number.isInteger(v) ? v : v.toFixed(1);
  if (typeof v !== 'string') return null;
  // ISO date-ish → compact date
  if (/^\d{4}-\d{2}-\d{2}T/.test(v)) {
    const d = new Date(v);
    if (!isNaN(d.getTime())) return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }
  return v;
}
